import Activities, { ActivityPayload } from '@/components/Activities'
import { getServiceAlertHistory } from '@/modules/Service/services'
import { useParams } from 'react-router-dom'

const AlertHistory = () => {
    const { id: serviceID } = useParams()
    const wrappedApiCall = ({ page, page_size }: ActivityPayload) =>
        getServiceAlertHistory({
            serviceID: Number(serviceID),
            params: {
                page,
                page_size,
            },
        })
    return (
        <Activities
            apiCall={wrappedApiCall}
            queryKey={`services.alerts.history.${serviceID}`}
        />
    )
}

export default AlertHistory
